// extracted by mini-css-extract-plugin
export default {"hour-log-page":"HourLogPage_hour-log-page__7jjzI","hour-log-title":"HourLogPage_hour-log-title__PcGQu"};